import { AUTHENTICATION_COOKIE_NAME } from '@packages/domain/constants/cookies';
import type { RootState } from 'reducers/types';
import { getRefreshToken } from 'selectors/entities/authentication/authentication';
import { getKeepSession } from 'selectors/ui/authentication/authentication';
import { cookies } from 'utils/cookies/cookies';

function flywireDomain() {
  return (window.location.host.match(/(flywire.*)/) || [])?.[0];
}

export const getStoredRefreshToken = () => {
  try {
    const serializedRefreshToken = cookies.read(AUTHENTICATION_COOKIE_NAME);

    if (serializedRefreshToken === null) {
      return undefined;
    }

    const { refreshToken } = JSON.parse(serializedRefreshToken);
    return refreshToken;
  } catch (_err) {
    return undefined;
  }
};

export const loadStateFromCookie = () => {
  try {
    const serializedRefreshToken = cookies.read(AUTHENTICATION_COOKIE_NAME);

    if (serializedRefreshToken === null) {
      return undefined;
    }

    const { refreshToken, keepSession } = JSON.parse(serializedRefreshToken);
    return {
      entities: {
        authentication: {
          refreshToken: decodeURIComponent(refreshToken),
        },
      },
      ui: {
        authentication: {
          keepSession,
        },
      },
    };
  } catch (_err) {
    return undefined;
  }
};

export const saveStateToCookie = (state: RootState) => {
  try {
    const shouldKeepSession = getKeepSession(state);
    const refreshToken = getRefreshToken(state);

    if (!refreshToken) {
      return;
    }

    cookies.set(
      AUTHENTICATION_COOKIE_NAME,
      JSON.stringify({
        refreshToken: encodeURIComponent(refreshToken),
        keepSession: shouldKeepSession,
      }),
      !shouldKeepSession,
      flywireDomain(),
    );
  } catch (_e) {
    // do nothing
  }
};

export const removeCookiesAuth = () => {
  cookies.delete(AUTHENTICATION_COOKIE_NAME, flywireDomain());
};
